import OBTLoading from './OBTLoading';
export default OBTLoading;
